export default __webpack_public_path__ + "static/media/hope-logo-elongated.82300fc4.jpeg";